module.exports = __webpack_public_path__ + "static/media/01.80458fb9.png";